import React, { Component } from "react";
import "./BuildingRow.css";
import { withStyles } from "@material-ui/core";

export var styles = function styles(theme) {
	return {
		menuRoot: {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.primary.contrastText,
			height: "100%",
			display: "flex",
			flexDirection: "column",
		},
		container: { flex: "0 0 180px", backgroundColor: "white", marginRight: "4px", padding: "0px" },
		menuItem: {
			textAlign: "center",
			cursor: "pointer",
			"&:hover, & div:hover": {
				backgroundColor: theme.palette.primary.dark,
				transition: "0.3s",
			},
		},
		menuItemSelected: {
			backgroundColor: theme.palette.primary.dark,
		},
		logo: {
			fontWeight: 700,
			whiteSpace: "pre-wrap",
			fontSize: "18px",
		},
	};
};

class BuildingRow extends Component {
	render() {
		var buildingData = this.props.buildingData;
		var nameClass = "building-name";
		nameClass += " client-portal-building-name";

		return (
			<div className={"building-wrapper" + (this.props.Condensed ? "-condensed" : "") + " " + (this.props.Selected ? "building-selected" : "")} onClick={(event) => this.props.onClick(buildingData)}>
				<div className="building-info">
					<label className={nameClass}>{buildingData.building_name}</label>
					{/* {buildingData.track_last_maint && buildingData.last_maint > 10 && <span className={"last-maint " + (this.props.Condensed ? "d-block " : "") + (buildingData.last_maint > 30 ? "last-maint-red" : "last-maint-orange")}>Last maint. was {buildingData.last_maint} days ago</span>} */}
					{!this.props.Condensed && <span style={{ display: "block" }} dangerouslySetInnerHTML={{ __html: buildingData.building_address }}></span>}
				</div>
			</div>
		);
	}
}

export default withStyles(styles, { withTheme: true })(BuildingRow);
